var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfDownloadMobileHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25V29H35V25",
    stroke: "#03AB70",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7V23M8 23L4 19M8 23L12 19",
    stroke: "#03AB70",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.553 10.74C18.3083 10.74 18.906 10.9307 19.346 11.312C19.7933 11.686 20.017 12.203 20.017 12.863C20.017 13.523 19.7933 14.0437 19.346 14.425C18.906 14.8063 18.3083 14.997 17.553 14.997H15.694V18H15.144V10.74H17.553ZM17.487 14.48C18.1177 14.48 18.598 14.3407 18.928 14.062C19.2653 13.7833 19.434 13.3837 19.434 12.863C19.434 12.3497 19.2653 11.9537 18.928 11.675C18.598 11.389 18.1177 11.246 17.487 11.246H15.694V14.48H17.487ZM23.4481 10.74C24.6067 10.74 25.4977 11.048 26.1211 11.664C26.7517 12.2727 27.0671 13.1563 27.0671 14.315C27.0671 15.503 26.7517 16.416 26.1211 17.054C25.4977 17.6847 24.6067 18 23.4481 18H21.1601V10.74H23.4481ZM23.4921 17.494C24.4601 17.494 25.2007 17.2227 25.7141 16.68C26.2347 16.13 26.4951 15.3417 26.4951 14.315C26.4951 13.3323 26.2347 12.577 25.7141 12.049C25.2007 11.5137 24.4601 11.246 23.4921 11.246H21.7101V17.494H23.4921ZM29.0152 11.246V14.051H32.5022V14.568H29.0152V18H28.4652V10.74H33.4152V11.246H29.0152Z",
    fill: "#03AB70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownloadMobileHover);
export default __webpack_public_path__ + "static/media/pdf-download-mobile-hover.d9dae587.svg";
export { ForwardRef as ReactComponent };